/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * The parameter to be set as input for the execution of the script in the Mocker.
 */

// required attributes
const ScriptParameterR = t.interface({
  name: t.string,

  value: t.string
});

// optional attributes
const ScriptParameterO = t.partial({});

export const ScriptParameter = t.intersection(
  [ScriptParameterR, ScriptParameterO],
  "ScriptParameter"
);

export type ScriptParameter = t.TypeOf<typeof ScriptParameter>;
